import { InputAdornment, TextField } from '@mui/material';
import { GridSearchIcon } from '@mui/x-data-grid';
import React from 'react';

interface Searchbar {
	searchTerm: string;
	setSearchTerm: any;
	label: string;
}

const SearchBar: React.FC<Searchbar> = ({ searchTerm, setSearchTerm, label }) => (
	<div>
		<TextField
			fullWidth
			label={label}
			variant="outlined"
			margin="normal"
			value={searchTerm}
			onChange={(e) => setSearchTerm(e.target.value)}
			size="small"
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<GridSearchIcon />
					</InputAdornment>
				),
			}}
		/>
	</div>
);

export default SearchBar;
